function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "intro-pattern_svg__a",
  x1: "75.365%",
  x2: "29.95%",
  y1: "11.439%",
  y2: "71.195%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("path", {
  id: "intro-pattern_svg__b",
  d: "M0 0h494v266H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#intro-pattern_svg__a)",
  d: "M68.102 101.393C49.493 122.093 28.034 164.08 28 201.125v.188c.011 10.204 1.652 20.032 5.432 28.93 16.83 39.63 61.67 46.78 106.001 6.58 49.64-45 136.08-45.59 65.4 89.18-64.841 123.63 168.59 78.88 249.69-47.269 32.232-50.14 45.591-90.451 45.861-120.789v-1.883c-.628-68.792-69.779-84.856-137.022-46.429-62.52 35.701-141.689 52.2-120.879-2.3C258.62 65.074 231.251 39 189.207 39c-35.677 0-81.925 18.784-121.105 62.393",
  transform: "rotate(170 245.776 199.22)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.315 51)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "intro-pattern_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#intro-pattern_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#111",
  strokeLinecap: "square",
  strokeOpacity: 0.05,
  mask: "url(#intro-pattern_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M578 191.5H-24m602 40H-24m602 41H-24m602-242H-24m602 40H-24m602 41H-24m602 40H-24m602-202H-24m602 41H-24m120 482v-602m-41 602v-602m-40 602v-602m242 602v-602m-40 602v-602m-41 602v-602m-40 602v-602m282 602v-602m-40 602v-602m-41 602v-602m-40 602v-602m161 602v-602"
}))));

function SvgIntroPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 517,
    height: 349
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTE3IiBoZWlnaHQ9IjM0OSI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNzUuMzY1JSIgeDI9IjI5Ljk1JSIgeTE9IjExLjQzOSUiIHkyPSI3MS4xOTUlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkZGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjRTRFOEYyIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBpZD0iYiIgZD0iTTAgMGg0OTR2MjY2SDB6Ii8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTY4LjEwMiAxMDEuMzkzQzQ5LjQ5MyAxMjIuMDkzIDI4LjAzNCAxNjQuMDggMjggMjAxLjEyNXYuMTg4Yy4wMTEgMTAuMjA0IDEuNjUyIDIwLjAzMiA1LjQzMiAyOC45MyAxNi44MyAzOS42MyA2MS42NyA0Ni43OCAxMDYuMDAxIDYuNTggNDkuNjQtNDUgMTM2LjA4LTQ1LjU5IDY1LjQgODkuMTgtNjQuODQxIDEyMy42MyAxNjguNTkgNzguODggMjQ5LjY5LTQ3LjI2OSAzMi4yMzItNTAuMTQgNDUuNTkxLTkwLjQ1MSA0NS44NjEtMTIwLjc4OXYtMS44ODNjLS42MjgtNjguNzkyLTY5Ljc3OS04NC44NTYtMTM3LjAyMi00Ni40MjktNjIuNTIgMzUuNzAxLTE0MS42ODkgNTIuMi0xMjAuODc5LTIuM0MyNTguNjIgNjUuMDc0IDIzMS4yNTEgMzkgMTg5LjIwNyAzOWMtMzUuNjc3IDAtODEuOTI1IDE4Ljc4NC0xMjEuMTA1IDYyLjM5MyIgdHJhbnNmb3JtPSJyb3RhdGUoMTcwIDI0NS43NzYgMTk5LjIyKSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyLjMxNSA1MSkiPjxtYXNrIGlkPSJjIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNiIi8+PC9tYXNrPjxnIHN0cm9rZT0iIzExMSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIgbWFzaz0idXJsKCNjKSI+PHBhdGggZD0iTTU3OCAxOTEuNUgtMjRNNTc4IDIzMS41SC0yNE01NzggMjcyLjVILTI0TTU3OCAzMC41SC0yNE01NzggNzAuNUgtMjRNNTc4IDExMS41SC0yNE01NzggMTUxLjVILTI0TTU3OC01MC41SC0yNE01NzgtOS41SC0yNE05NiA0NzIuNXYtNjAyTTU1IDQ3Mi41di02MDJNMTUgNDcyLjV2LTYwMk0yNTcgNDcyLjV2LTYwMk0yMTcgNDcyLjV2LTYwMk0xNzYgNDcyLjV2LTYwMk0xMzYgNDcyLjV2LTYwMk00MTggNDcyLjV2LTYwMk0zNzggNDcyLjV2LTYwMk0zMzcgNDcyLjV2LTYwMk0yOTcgNDcyLjV2LTYwMk00NTggNDcyLjV2LTYwMiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgIntroPattern as ReactComponent };